export type PostDynamicContentConditions = Record<string, boolean>;

export enum PostDynamicContentConditionOperator {
  AND = 'and',
  OR = 'or',
}
